/**
 * @chineseName 统计数值
 * @subDescription m-ui组件 统计数值
 */
import Statistic from './Statistic';
import Countdown from './Countdown';
Statistic.Countdown = Countdown;
export default Statistic;